import React, { useState } from 'react';
import { Modal } from '../../components';
import css from './ClothingSizeChartModal.module.css';

const straightData = {
  sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', 'OS'],
  chest: [
    '86–91 cm (34–36")',
    '92–97 cm (36–38")',
    '98–102 cm (38–40")',
    '103–107 cm (40–42")',
    '108–112 cm (42–44")',
    '113–117 cm (44–46")',
    '118–123 cm (46–48")',
    'Fits Most',
  ],
  waist: [
    '71–76 cm (28–30")',
    '77–81 cm (30–32")',
    '82–86 cm (32–34")',
    '87–91 cm (34–36")',
    '92–96 cm (36–38")',
    '97–101 cm (38–40")',
    '102–107 cm (40–42")',
    'Fits Most',
  ],
  hips: [
    '86–91 cm (34–36")',
    '92–96 cm (36–38")',
    '97–101 cm (38–40")',
    '102–106 cm (40–42")',
    '107–111 cm (42–44")',
    '112–116 cm (44–46")',
    '117–122 cm (46–48")',
    'Fits Most',
  ],
};

const contouredData = {
  sizes: ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', 'OS'],
  eur: ['34', '36–38', '40', '42', '44', '46', '48', 'One Size'],
  ukUs: [
    'UK 6 / US 2',
    'UK 8–10 / US 4–6',
    'UK 12 / US 8',
    'UK 14 / US 10',
    'UK 16 / US 12',
    'UK 18 / US 14',
    'UK 20 / US 16',
    'Fits Most',
  ],
  bust: [
    '82–85 cm (32–33")',
    '86–89 cm (34–35")',
    '90–93 cm (35–37")',
    '94–97 cm (37–38")',
    '98–101 cm (38–40")',
    '102–105 cm (40–41")',
    '106–110 cm (42–43")',
    'Fits Most',
  ],
  waist: [
    '61–64 cm (24–25")',
    '65–68 cm (25–27")',
    '69–72 cm (27–28")',
    '73–76 cm (28–30")',
    '77–80 cm (30–31")',
    '81–84 cm (31–33")',
    '85–89 cm (33–35")',
    'Fits Most',
  ],
  hips: [
    '88–91 cm (34–35")',
    '92–95 cm (36–37")',
    '96–99 cm (37–39")',
    '100–103 cm (39–40")',
    '104–107 cm (40–42")',
    '108–111 cm (42–43")',
    '112–116 cm (44–46")',
    'Fits Most',
  ],
};

const ClothingSizeChartModal = ({ isOpen, onClose }) => {
  const [activeTab, setActiveTab] = useState('straight');

  return (
    <Modal
      id="ClothingSizeChartModal"
      isOpen={isOpen}
      onClose={onClose}
      onManageDisableScrolling={() => {}}
      containerClassName={css.modalContainer}
      closeButtonMessage="Close"
      usePortal
    >
      <div className={css.root}>
        <button className={css.closeButton} onClick={onClose} aria-label="Close">
          ×
        </button>
        <h2 className={css.title}>CLOTHING SIZE CHART</h2>

        <div className={css.tabsContainer}>
          <button
            type="button"
            className={`${css.tabButton} ${activeTab === 'straight' ? css.activeTabButton : ''}`}
            onClick={() => setActiveTab('straight')}
          >
            Straight / Regular Sizing
          </button>
          <button
            type="button"
            className={`${css.tabButton} ${activeTab === 'contoured' ? css.activeTabButton : ''}`}
            onClick={() => setActiveTab('contoured')}
          >
            Contoured / Fitted Sizing
          </button>
        </div>

        <div className={css.tableWrapper}>
          <table className={css.sizeTable}>
            <thead>
              <tr className={css.headerRow}>
                <th className={css.standardHeader} colSpan={straightData.sizes.length + 1}>
                  {activeTab === 'straight' ? 'STRAIGHT / REGULAR CUT' : 'CONTOURED / FITTED CUT'}
                </th>
              </tr>
              <tr className={css.columnHeaders}>
                <th className={css.firstColumn}></th>
                {straightData.sizes.map((size, index) => (
                  <th key={index}>
                    <strong>{size}</strong>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {activeTab === 'straight' && (
                <>
                  <tr className={css.sizeRow}>
                    <td className={css.rowLabel}>
                      <strong>CHEST</strong>
                    </td>
                    {straightData.chest.map((value, index) => (
                      <td key={index}>{value}</td>
                    ))}
                  </tr>
                  <tr className={css.sizeRow}>
                    <td className={css.rowLabel}>
                      <strong>WAIST</strong>
                    </td>
                    {straightData.waist.map((value, index) => (
                      <td key={index}>{value}</td>
                    ))}
                  </tr>
                  <tr className={css.sizeRow}>
                    <td className={css.rowLabel}>
                      <strong>HIPS</strong>
                    </td>
                    {straightData.hips.map((value, index) => (
                      <td key={index}>{value}</td>
                    ))}
                  </tr>
                </>
              )}

              {activeTab === 'contoured' && (
                <>
                  <tr className={css.sizeRow}>
                    <td className={css.rowLabel}>
                      <strong>EUR</strong>
                    </td>
                    {contouredData.eur.map((value, index) => (
                      <td key={index}>{value}</td>
                    ))}
                  </tr>
                  <tr className={css.sizeRow}>
                    <td className={css.rowLabel}>
                      <strong>UK / US</strong>
                    </td>
                    {contouredData.ukUs.map((value, index) => (
                      <td key={index}>{value}</td>
                    ))}
                  </tr>
                  <tr className={css.sizeRow}>
                    <td className={css.rowLabel}>
                      <strong>BUST</strong>
                    </td>
                    {contouredData.bust.map((value, index) => (
                      <td key={index}>{value}</td>
                    ))}
                  </tr>
                  <tr className={css.sizeRow}>
                    <td className={css.rowLabel}>
                      <strong>WAIST</strong>
                    </td>
                    {contouredData.waist.map((value, index) => (
                      <td key={index}>{value}</td>
                    ))}
                  </tr>
                  <tr className={css.sizeRow}>
                    <td className={css.rowLabel}>
                      <strong>HIPS</strong>
                    </td>
                    {contouredData.hips.map((value, index) => (
                      <td key={index}>{value}</td>
                    ))}
                  </tr>
                </>
              )}
            </tbody>
          </table>
        </div>

        <div className={css.note}>
          <p>
            <em>
              This is a general sizing guide. Actual fit may vary depending on the brand, material, stretch, garment style, and manufacturer.
            </em>
          </p>
        </div>
      </div>
    </Modal>
  );
};

export default ClothingSizeChartModal;

